export const BASE_ADMIN_API_ROOT_PATH = `${process.env.REACT_APP_API}/admin`;
